import Vue from "vue";
import Vuex from "vuex";
import routerData from "./routerData";
import dialog from "./dialog";
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    dialog,
    routerData,
  },
});

export default store;
